import React from 'react';
import PropTypes from 'prop-types';
import loadable from 'src/common/loadable';
import { getText } from '../../utils/i18n';
import './index.scss';

const AsyncTradeAlert = loadable(
  () => import(/** trade-alert */ './trade-alert'),
  {
    loadingVisible: false,
    name: 'trade-alert',
  },
);

class ModuleBreadcrumb extends React.PureComponent {
  static propTypes = {
    breadCrumb: PropTypes.object,
    domainName: PropTypes.string,
    productIsMarketGoods: PropTypes.bool,
    isSpecificGoods: PropTypes.bool,
    i18n: PropTypes.object,
    productCategoryId: PropTypes.number,
  };

  state = {
    shouldRenderTradeAlert: false,
  };

  componentDidMount() {
    // 延后加载
    setTimeout(() => {
      this.setState({
        shouldRenderTradeAlert: true,
      });
    }, 2000);
  }

  getAbsoluteUrl(path) {
    const { domainName } = this.props;
    const pattern = /https?:\/\//;
    if (pattern.test(path)) {
      return path;
    } else {
      return `${domainName}${path}`;
    }
  }

  render() {
    const {
      breadCrumb = {},
      domainName,
      productIsMarketGoods,
      isSpecificGoods,
      i18n,
      productCategoryId,
    } = this.props;

    if (!breadCrumb.pathList || breadCrumb.pathList.length === 0) return null;

    let resultDomainName = domainName;
    if (resultDomainName.indexOf('//') === -1) {
      resultDomainName = `//${resultDomainName}`;
    }
    resultDomainName = `https:${resultDomainName}`;

    const { shouldRenderTradeAlert } = this.state;

    return (
      <div className="detail-subscribe" data-spm="debelsubf">
        <ol
          className="detail-breadcrumb"
          itemScope
          itemType="http://schema.org/BreadcrumbList"
        >
          <li
            className="breadcrumb-item"
            itemProp="itemListElement"
            itemScope
            itemType="http://schema.org/ListItem"
          >
            <a
              className="breadcrumb-link"
              itemProp="item"
              href={resultDomainName}
            >
              <span itemProp="name">
                {productIsMarketGoods && !isSpecificGoods
                  ? getText(
                      i18n,
                      'icbu_esite_pc_breadcrumb_market',
                      'Wholesale',
                    )
                  : getText(i18n, 'icbu_esite_pc_breadcrumb_sourcing', 'Home')}
              </span>
            </a>
            <meta itemProp="position" content="0" />
            <span className="seperator">&gt;</span>
          </li>
          {breadCrumb.pathList.map((breadItem, index) => {
            return (
              <li
                className="breadcrumb-item"
                itemProp="itemListElement"
                key={index}
                itemScope
                itemType="http://schema.org/ListItem"
              >
                <a
                  className="esite-link-default breadcrumb-link"
                  itemProp="item"
                  href={this.getAbsoluteUrl(breadItem.hrefObject.url)}
                >
                  <span itemProp="name">{breadItem.hrefObject.name}</span>
                </a>
                <meta itemProp="position" content={index + 1} />
                {index < breadCrumb.pathList.length - 1 ? (
                  <span className="seperator">&gt;</span>
                ) : null}
              </li>
            );
          })}
        </ol>
        <div className="trade-alert J-trade-alert" />

        {shouldRenderTradeAlert ? (
          <AsyncTradeAlert
            selector=".J-trade-alert"
            categoryId={productCategoryId}
            i18n={i18n}
          />
        ) : null}
      </div>
    );
  }
}

export default ModuleBreadcrumb;
